import { render, staticRenderFns } from "./DataAuthList.vue?vue&type=template&id=fe7ae01a&scoped=true&"
import script from "./DataAuthList.vue?vue&type=script&lang=js&"
export * from "./DataAuthList.vue?vue&type=script&lang=js&"
import style0 from "./DataAuthList.vue?vue&type=style&index=0&id=fe7ae01a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7ae01a",
  null
  
)

export default component.exports